export default __webpack_public_path__ + "static/logo-PB-footer-f051eb03738d19a28a27df1e3f03eda5.png";